import React from "react";
import { InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export default function UserFilter({ value, onChange }) {
    return (
        <TextField
            value={value}
            onChange={(event) => onChange(event.target.value)}
            label="Rechercher un utilisateur"
            placeholder="Nom de l'utilisateur"
            size="small"
            fullWidth
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon fontSize="small" />
                    </InputAdornment>
                ),
            }}
        />
    );
}
